<router-outlet></router-outlet>

<app-confirm-dialog />

<app-toast type="2"></app-toast>
